import "./Footer.css";
import { useNavigate } from "react-router-dom";
import fourMMlogo from "../assets/fourMMlogo.png";

const Footer = () => {
    const navigate = useNavigate();

    // Array of objects for each footer column
    const footerLinks = [
        {
            title: "Explore",
            links: [
                { name: "Job Board", href: "/" },
                // { name: "Pricing", href: "#pricing" },
                { name: "Contact us", href: "https://tally.so/r/wb6krg", blank: true },
            ],
        },
        {
            title: "Company",
            links: [
                {
                    name: "Our Story",
                    href: "https://www.fourminutemedicine.com/our-story",
                    blank: true,
                },
                {
                    name: "FAQs",
                    href: "#faq"
                },
                // { name: "Become a Creator", href: "#" },
                // { name: "Help center", href: "/contact-support", blank: true },
            ],
        },
        {
            title: "Our Products",
            links: [
                {
                    name: "Four Minute Medicine",
                    href: "https://www.fourminutemedicine.com/",
                    blank: true,
                },
                // { name: "Medhi", href: "#" },
                {
                    name: "Certlist",
                    href: "https://certlist.org/",
                    blank: true,
                },
                {
                    name: "SupTrac",
                    href: "https://www.suptrac.com/",
                    blank: true,
                },
            ],
        },
        {
            title: "Legals",
            links: [
                {
                    name: "Privacy Policy",
                    href: "https://www.fourminutemedicine.com/files/privacy-policy.pdf",
                    blank: true,
                },
                {
                    name: "Terms of Service",
                    href: "https://www.fourminutemedicine.com/files/terms-and-conditions.pdf",
                    blank: true,
                },
                {
                    name: "Disclaimer",
                    href: "/disclaimer",
                },
                // {
                //     name: "Refund and Cancellation Policy",
                //     href: "https://learn.fourminutemedicine.com/refund-and-cancellation-policy/",
                //     blank: true,
                // },
                // { name: "Cookie preferences", href: "#" },
                // { name: "Sitemap", href: "#" },--for SEO purposes, we don't need a link here
            ],
        },
    ];

    return (
        <footer className="bg-black text-gray-300 py-12 px-4 md:px-8 font-inter">
            <div className="max-w-7xl mx-auto flex flex-col lg:flex-row lg:justify-between lg:items-start gap-12">
                {/* Links section */}
                <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12 flex-grow">
                    {footerLinks.map((section, index) => (
                        <div key={index} className="flex flex-col space-y-4">
                            <h4 className="text-white font-semibold text-lg">
                                {section.title}
                            </h4>
                            <ul className="space-y-2">
                                {section.links.map((link, linkIndex) => (
                                    <li key={linkIndex}>
                                        <a
                                            href={link.href}
                                            className="text-white text-sm hover:underline transition-colors duration-200"
                                            target={
                                                link.blank ? "_blank" : "_self"
                                            }
                                        >
                                            {link.name}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                {/* Logo and social icons section */}
                <div className="flex flex-col items-start space-y-4 lg:space-y-20 mt-8 lg:mt-0">
                    <div className="flex flex-col items-center space-y-4">
                        <div
                            className="logo cursor-pointer"
                            onClick={() => navigate("/")}
                        >
                            <span className="logo-text text-white">Doctors' Jobs</span> <span className="logo-badge">Beta</span>
                        </div>
                        {/* <a
                            href="https://www.instagram.com/suptrac/"
                            aria-label="Instagram"
                        >
                            <FaInstagram
                                size={24}
                                className="text-white hover:text-gray-400 transition-colors duration-200"
                            />
                        </a> */}
                    </div>
                </div>
            </div>

            {/* Copyright section */}
            <div className="flex items-center justify-between max-w-7xl mx-auto mt-8 pt-6 text-center lg:text-left">
                <p className="text-white text-sm">
                    © Copyright {new Date().getFullYear()} Four Minute Medicine (PTY) LTD. All rights
                    reserved.
                </p>
                {/* Four Minute Medicine logo */}
                <div className="w-24">
                    {/* <FourMinuteMedicineLogo /> */}
                    <a href="https://www.fourminutemedicine.com/" target="_blank" rel="noopener noreferrer">
                        <img
                            src={fourMMlogo}
                            alt="Four Minute Medicine Logo"
                            className="w-full"
                        />
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
